import React, { useState } from 'react'
import { CircularProgress } from '@mui/material'
import AlertDialog from '../../../components/AlertDialog/index.es6'

// Same forgotpassword flow as the login page's "Recover Password".
const ResetPartnerUserPassword = props => {
  const [confirmed, setConfirmed] = useState(false)

  if (!props.user) {
    return ''
  }

  const displayName =
    [props.user.firstName, props.user.lastName].filter(Boolean).join(' ') ||
    props.user.username

  const close = () => {
    setConfirmed(false)
    props.clearResetPasswordState()
    props.resetUserToResetPassword()
  }

  const confirm = () => {
    setConfirmed(true)
    props.resetPassword(props.user)
  }

  return (
    <>
      <AlertDialog
        warning
        show={!confirmed}
        size="sm"
        title={`Send a password reset email to ${displayName}?`}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => {
          close()
        }}
        onCancel={() => {
          confirm()
        }}
        confirmBtnText="Cancel"
        showCancel
        showConfirm
        cancelBtnText="Send Reset Email"
        confirmBtnCssClass
      >
        {props.user.email ? (
          <p>
            A reset link will be emailed to <strong>{props.user.email}</strong>.
          </p>
        ) : (
          <p>
            This user has no email address, so the reset email cannot be
            delivered.
          </p>
        )}
      </AlertDialog>

      <AlertDialog
        custom
        show={confirmed && !!props.showProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        showCancel={false}
        showConfirm={false}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Sending reset email</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={confirmed && !!props.showSuccessAlert}
        size="sm"
        title="Password reset email sent"
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => {
          close()
        }}
        confirmBtnText="Ok"
        showCancel={false}
        confirmBtnCssClass
      >
        {displayName} will receive an email with a link to set a new password.
      </AlertDialog>

      <AlertDialog
        danger
        show={confirmed && !!props.showErrorAlert}
        title="Error sending reset email"
        onConfirm={() => {
          close()
        }}
        confirmBtnText="Ok"
        showCancel={false}
        confirmBtnCssClass
        style={{ marginTop: '0', top: '30vh' }}
      >
        Could not send the password reset email
      </AlertDialog>
    </>
  )
}

export default ResetPartnerUserPassword
